import { formatUsd } from "@/utils/number-format";

/** The Buy Credits modal's own minimum purchase, in USD. */
export const MODAL_MIN_USD = 50;
/** What the modal starts at when the caller pre-fills nothing. */
export const DEFAULT_BUY_USD = 500;

/** The lowest amount the modal accepts: its own $50 minimum, raised to a caller's `minUsd`. */
export function buyFloorUsd(minUsd?: number): number {
  return Math.max(MODAL_MIN_USD, minUsd ?? 0);
}

/** The amount the modal opens with: $500 by default, else the pre-fill rounded up and lifted to the floor. */
export function initialBuyUsd(initialUsd?: number, minUsd?: number): number {
  if (initialUsd === undefined) return DEFAULT_BUY_USD;
  return Math.max(buyFloorUsd(minUsd), Math.ceil(initialUsd));
}

/** Refuses an amount below the floor, only when the caller set `minUsd`. Null when acceptable. */
export function buyAmountError(usd: number, minUsd?: number): string | null {
  if (minUsd === undefined) return null;
  const floor = buyFloorUsd(minUsd);
  if (usd >= floor) return null;
  return `Enter at least ${formatUsd(floor)}.`;
}
